import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';

export const SPARE_PARTS_INTERNAL_TICKET_LIST_FETCH_PENDING = 'SPARE_PARTS_INTERNAL_TICKET_LIST_FETCH_PENDING';

export const fetchSparePartsInternalTicketListPageData = (pageSize, sorted, cursor, isNextFromPivot, filtered) => dispatch => {
    dispatch({
        type: SPARE_PARTS_INTERNAL_TICKET_LIST_FETCH_PENDING,
        sparePartsWebsocket: true,
        command: sparePartsWebsocketCommands.SPARE_PARTS_INTERNAL_TICKET_LIST_GET,
        payload: {pageSize: pageSize, sorted: sorted, cursor, isNextFromPivot, filtered: filtered}
    });
};
